export const LabelInput = ({
  inputId,
  required = true,
  type = "text",
  label,
  placeholder,
  onChange,
  value,
  labelStyle = {},
  inputStyle = {},
  containerStyle = {},
  maxLength = 50,
  onBlur,
  name,
  pattern,
}) => {
  return (
    <div style={{ marginBottom: "10px", ...containerStyle }}>
      <label style={{ display: "block", marginBottom: "4px", ...labelStyle }}>
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </label>
      <input
        name={name}
        id={inputId}
        required={required}
        type={type}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        style={{
          padding: "10px",
          width: "100%",
          borderRadius: "8px",
          border: "1px solid #ccc",
          ...inputStyle,
        }}
        pattern={pattern}
        maxLength={maxLength}
        onBlur={onBlur} // Added onBlur prop here
      />
    </div>
  );
};

export const LabelTextarea = ({
  required = true,
  label,
  placeholder,
  onChange,
  value,
  name,
  labelStyle = {},
  textareaStyle = {},
  containerStyle = {},
}) => {
  return (
    <div style={{ marginBottom: "10px", ...containerStyle }}>
      <label style={{ display: "block", marginBottom: "4px", ...labelStyle }}>
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </label>
      <textarea
        name={name}
        required={required}
        className="footer-textarea"
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        style={{
          padding: "10px",
          width: "100%",
          borderRadius: "8px",
          border: "1px solid #ccc",
          resize: "vertical",
          maxHeight: "100px",
          ...textareaStyle,
        }}
        maxLength={150}
      />
    </div>
  );
};
